<template>
  <div class="summary">
    <img class="summary__banner" :src="banner" alt="Banner de la compañia" />
    <a-avatar
      v-if="avatar"
      :src="avatar"
      :size="78"
      class="summary__avatar"
      alt="Avatar de perfil"
    />
    <DefaultIconLetter
      v-else
      :names="names"
      :size="78"
      class="summary__avatar"
    />
    <div class="summary__body">
      <h6 v-if="planName" class="semibold-12 mrg-bottom-4">{{ planName }}</h6>
      <h6 v-if="names" class="heading-h7">{{ names }}</h6>
      <p v-if="companyName" class="body-2 mrg-bottom-12">
        {{ companyName }}
      </p>
      <p v-if="email" class="body-1" style="margin-bottom: 6px; color: #686a6f">
        <a-icon type="mail" /> {{ email }}
      </p>
      <p
        v-if="typeUser"
        class="body-1"
        style="margin-bottom: 6px; color: #686a6f"
      >
        <a-icon type="smile" /> {{ typeUser }}
      </p>
      <p
        v-if="username"
        class="body-1"
        style="margin-bottom: 6px; color: #686a6f"
      >
        <a-icon type="user" /> {{ username }}
      </p>
      <p
        v-if="phoneNumber"
        class="body-1"
        style="margin-bottom: 6px; color: #686a6f"
      >
        <a-icon type="mobile" /> {{ phoneNumber }}
      </p>
    </div>
  </div>
</template>

<script>
import DefaultIconLetter from '@/app/shared/components/avatars/DefaultIconLetter.vue'

export default {
  name: 'SummaryAccount',
  components: {
    DefaultIconLetter,
  },
  props: {
    names: { type: String, required: false, default: null },
    email: { type: String, required: false, default: null },
    companyName: { type: String, required: false, default: null },
    username: { type: String, required: false, default: null },
    phoneNumber: { type: String, required: false, default: null },
    avatar: { type: String, required: false },
    banner: {
      type: String,
      required: false,
      default: require('@/app/shared/assets/bg-profile.png'),
    },
    typeUser: { type: String, required: false, default: null },
    planName: { type: String, required: false, default: null },
  },
}
</script>

<style lang="sass" scoped>
.mrg-bottom-12
  margin-bottom: 12px
.mrg-bottom-4
  margin-bottom: 4px

.summary
  width: 100%
  position: relative
  display: flex
  justify-content: center
  &__banner
    width: 100%
    height: 87px
    background-size: cover
    border-radius: 4px 4px 0px 0px
    cursor: auto
    object-fit: cover
  &__avatar
    position: absolute
    top: 46px
    border: 3px solid $white_000

  &__body
    position: absolute
    top: 135px
    display: flex
    flex-direction: column
    align-items: center
    color: $gray_dark_900
    padding: 0 20px
</style>
<style lang="sass">
.summary__avatar
  .ant-avatar-string
    line-height: 72px!important
</style>
